"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "@/components/waves/drops/WaveDropContent";
import { useRouter } from "next/navigation";
import WaveDropReactions from "@/components/waves/drops/WaveDropReactions";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import { getWaveRoute } from "@/helpers/navigation.helpers";
interface WaveLeaderboardDropContentProps {
  readonly drop: ExtendedDrop;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaContainerHeightClassName?: string | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const WaveLeaderboardDropContent: React.FC<WaveLeaderboardDropContentProps> = t0 => {
  const $ = _c(14);
  const {
    drop,
    isCompetitionDrop: t1,
    mediaContainerHeightClassName,
    contentPresentation: t2
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const contentPresentation = t2 === undefined ? "default" : t2;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t3;
  if ($[0] !== router) {
    t3 = clickedDrop => {
      const href = getWaveRoute({
        waveId: clickedDrop.wave.id,
        serialNo: clickedDrop.serial_no,
        isDirectMessage: false,
        isApp: false
      });
      router.push(href);
    };
    $[0] = router;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onDropContentClick = t3;
  let t4;
  if ($[2] !== activePartIndex || $[3] !== contentPresentation || $[4] !== drop || $[5] !== isCompetitionDrop || $[6] !== mediaContainerHeightClassName || $[7] !== onDropContentClick) {
    t4 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} isCompetitionDrop={isCompetitionDrop} mediaContainerHeightClassName={mediaContainerHeightClassName} contentPresentation={contentPresentation} />;
    $[2] = activePartIndex;
    $[3] = contentPresentation;
    $[4] = drop;
    $[5] = isCompetitionDrop;
    $[6] = mediaContainerHeightClassName;
    $[7] = onDropContentClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== drop) {
    t5 = <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1"><WaveDropReactions drop={drop} /></div>;
    $[9] = drop;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="-tw-mt-0.5 tw-flex tw-flex-col tw-gap-y-1">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
function _temp() {}
function _temp2() {}
function _temp3() {}